var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { FloatingFocusManager } from '@floating-ui/react';
import { cloneElement } from 'react';
import { mergeProps } from 'react-aria';
import CloseButton from './close-button';
import { useModal } from './modal-context';
import { panelStyle } from './styles';
function Panel(_a) {
    var { ariaLabel, children, closeButtonOverride, context, floatingProps, isNonModal = false, isVisible, onClose } = _a, restProps = __rest(_a, ["ariaLabel", "children", "closeButtonOverride", "context", "floatingProps", "isNonModal", "isVisible", "onClose"]);
    const { alignCenter, autoFocusRef, bodyId, headerId } = useModal();
    function renderCloseButton() {
        function handleClick() {
            var _a, _b;
            (_b = closeButtonOverride === null || closeButtonOverride === void 0 ? void 0 : (_a = closeButtonOverride.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a);
            onClose();
        }
        return closeButtonOverride != null ? (cloneElement(closeButtonOverride, {
            onClick: handleClick,
        })) : (_jsx(CloseButton, { onClick: onClose }));
    }
    return (_jsx(FloatingFocusManager, Object.assign({ context: context, initialFocus: isVisible ? -1 : autoFocusRef }, (isNonModal && {
        closeOnFocusOut: false,
        initialFocus: isVisible ? 0 : autoFocusRef,
        modal: false,
    }), { children: _jsxs("section", Object.assign({ "aria-modal": !isNonModal }, (ariaLabel == null &&
            headerId != null && { 'aria-labelledby': headerId }), (bodyId != null
            ? { 'aria-describedby': bodyId }
            : { 'aria-label': ariaLabel }), { css: panelStyle({
                alignCenter,
                isPositioned: !(context.middlewareData.arrow == null),
                isVisible,
                x: context.x,
                y: context.y,
            }) }, mergeProps(floatingProps, restProps), { children: [renderCloseButton(), children] })) })));
}
export default Panel;
